<svg viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M19 22v-3h2v5H0V3h5v2H2v17h17zm3.002-18.597L8.072 17.335 6.656 15.92l13.92-13.919H9.86v-2h14.142v14.142h-2V3.403z"/>
</svg>
